import { render, staticRenderFns } from "./RoleRequest.vue?vue&type=template&id=3dd39e96"
import script from "./RoleRequest.vue?vue&type=script&lang=js"
export * from "./RoleRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports